import { render, staticRenderFns } from "./updateInfoModal.vue?vue&type=template&id=d64a46ce"
import script from "./updateInfoModal.vue?vue&type=script&lang=js"
export * from "./updateInfoModal.vue?vue&type=script&lang=js"
import style0 from "./updateInfoModal.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports